import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Button, Col, Form, Input, Modal, Row } from 'antd'
import { useDeepEffect } from '../../../utils/hooks'
import MaterialList from '../../../components/MaterialList'

const BrandMaterialForm = (props) => {
  const { visible, onOk, onCancel, formData, form, materials, myMaterials } =
    props
  const { getFieldDecorator, validateFields } = form
  const [stateList, setStateList] = useState([])

  useDeepEffect(() => {
    setStateList(myMaterials.map((item) => item.id))
  }, [])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
      }
    })
  }

  function onClickItem(material) {
    let added = false
    stateList.forEach((item) => {
      if (item === material.id) {
        added = true
      }
    })

    if (added) {
      setStateList((prevState) => {
        _.remove(prevState, (product) => {
          return product === material.id
        })

        return [...prevState]
      })
    } else {
      setStateList((prevState) => {
        prevState.push(material.id)
        return [...prevState]
      })
    }
  }

  const renderItemActive = (item) => {
    let active = false

    if (!_.isEmpty(stateList)) {
      stateList.forEach((material) => {
        if (material === item.id) {
          active = true
        }
      })
    }

    return active
  }

  function onSaveMaterial() {
    onOk(stateList)
  }

  return (
    <Modal
      width={1000}
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Add'} Material`}
      visible={visible}
      onOk={onSaveMaterial}
      onCancel={onCancel}>
      <Form onSubmit={onSubmit} layout="vertical">
        <Row type="flex" gutter={8}>
          <Col span={20}>
            <Form.Item>
              {getFieldDecorator(`search`)(
                <Input placeholder="Search from material" />
              )}
            </Form.Item>
          </Col>
          <Col span={4}>
            <Button type="primary" style={{ width: '100%' }}>
              Search
            </Button>
          </Col>
        </Row>
      </Form>
      <MaterialList
        materials={materials}
        renderItemActive={renderItemActive}
        onClickItem={onClickItem}
      />
    </Modal>
  )
}

BrandMaterialForm.propTypes = {
  materials: PropTypes.array.isRequired,
  myMaterials: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedBrandMaterialForm = Form.create({ name: 'BrandMaterialForm' })(
  BrandMaterialForm
)

export default WrappedBrandMaterialForm



// WEBPACK FOOTER //
// ./src/pages/BrandMaterial/BrandMaterialForm/index.js